import React, { FunctionComponent } from 'react'
import CreatableSelect from 'react-select/creatable'

type OPTION = {
  value: string
  label: string
  id?: number
}

interface Props {
  name: string
  onSelect: (option: any) => void
  options: OPTION[]
  placeholder: string
  value?: OPTION | undefined
  show: boolean
}

let dropdownCount = 0

const Select: FunctionComponent<Props> = ({
  name,
  onSelect,
  options,
  placeholder,
  value,
  clickLabel,
  show,
}: Props) => {
  if (!(clickLabel + '').startsWith('ordersTableSettings')) {
    dropdownCount = 0
  }
  const styles = {
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? '#EDF2F7' : '#FFF',
      color: '#2D3748',
      padding: '0.5em 0.7em',
      '&:hover': {
        backgroundColor: '#F7FAFC',
      },
    }),
    control: provided => ({
      ...provided,
      width: '12em',
      background: 'transparent',
      color: '#2D3748',
      border: '1px solid #2D3748',
      boxShadow: 'none',
      borderRadius: '0.25rem',
      '&:hover': {
        borderColor: '#2D3748',
      },
      '&:focus': {
        outline: '5px auto -webkit-focus-ring-color',
      },
      '& svg': {
        color: '#718096',
        '&:hover': {
          color: '#718096',
        },
      },
    }),
    menu: provided => ({
      ...provided,
      boxShadow:
        '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
      overflow: 'hidden',
      zIndex: 3,
    }),
    menuList: provided => ({
      ...provided,
      padding: 0,
    }),
    singleValue: (provided, state) => {
      const opacity = state.isDisabled ? 0.5 : 1
      const transition = 'opacity 300ms'

      return { ...provided, opacity, transition }
    },
  }
	if (name === 'status-filter' && typeof options === 'object') {
		let sortedOptions = []
		options.sort((a, b) => {
			const nameA = a?.label
			const nameB = b?.label
			if (nameA > nameB) {
				return 1
			} else if (nameA < nameB) {
				return -1
			} else {
				return 0
			}
		}).forEach(option => {
			sortedOptions.push(option)
		})
		options = sortedOptions
	}

  // TODO fixs console error with controlled/uncontrolled value/onChange thing
  if (show) {
    return (
      <CreatableSelect
        inputId={`${name}-select`}
        styles={styles}
        value={value}
        isClearable
        options={options}
        onChange={onSelect}
        placeholder={placeholder}
      />
    )
  } else {
    return null
  }
}

export default Select
